// IE 2026 10 16 / ODOO-347204: экран входа — прогресс и понятные причины отказа
// Пользователь ждал ~1 мин с одним красным «…» под кнопками и решил, что её заблокировали.
// Здесь: порог подсказки «вход идёт долго» и чистая функция «ответ бэка / сбой HTTP → текст для человека».
import { t } from '@/i18n'

// IE 2026 10 16 / ODOO-347204: через сколько мс после старта запроса показывать «вход идёт дольше обычного»
export const LOGIN_SLOW_MS = 15000

// IE 2026 10 16 / ODOO-347204: текст, пришедший от сервера (JSON-ответ), без HTML-страниц ошибок прокси
function serverMessage(xhr) {
    const pick = (o) => {
        if (!o || typeof o !== 'object') return ''
        const c = [o.notification && o.notification.text, o.message, o.detail, o.error]
        for (const s of c) if (typeof s === 'string' && s.trim()) return s.trim()
        return ''
    }
    let m = pick(xhr && xhr.responseJSON)
    if (!m && xhr && typeof xhr.responseText === 'string' && xhr.responseText.trim().startsWith('{')) {
        try { m = pick(JSON.parse(xhr.responseText)) } catch (e) { /* не JSON — игнорируем */ }
    }
    return m
}

// IE 2026 10 16 / ODOO-347204: xhr — jqXHR/XMLHttpRequest-подобный объект { status, statusText, responseJSON, responseText }
export function loginErrorText(xhr) {
    const status = Number(xhr && xhr.status) || 0
    const msg = serverMessage(xhr)
    if (msg) return msg   // сообщение сервера, если есть, важнее нашего
    if (status === 401 || status === 403) return t('Sign-in failed. Check your email and password, then try again.')
    if (status >= 400) return t('Sign-in failed on the server (HTTP {code}). Try again later', { code: status })
    // status 0 / timeout / abort / parsererror: ответа сервера нет
    return t('Could not reach the server. Check your connection and try again')
}
